<template>
    <div class="overflow-hidden py-20 sm:py-32">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="lg:grid lg:grid-cols-12 lg:gap-x-8 lg:gap-y-20">
                <div class="relative z-10 mx-auto max-w-2xl lg:col-span-7 lg:max-w-none lg:pt-6 xl:col-span-6">
                    <span class="text-gray-600 mb-2 block">{{ data.subtitle }}</span>
                    <h1 class="text-4xl font-medium tracking-tight text-gray-900">{{ data.title }}</h1>
                    <p class="mt-6 text-lg text-gray-600">
                        {{ data.description }}
                    </p>
                    <div class="mt-8 flex flex-wrap gap-x-6 gap-y-4">
                        <Button variant="primary" size="sm" :href=data.buttonLink @click="bookDemoModal = true">
                            <span class="text-sm font-semibold text-white">{{ data.buttonText }}</span>
                        </Button>

                        <Dialog v-model:visible="bookDemoModal" modal header="Request a Demo" :style="{ width: '50rem' }">
                            <div class="flex items-center gap-4 mb-4">
                                <label for="email" class="font-semibold w-24">email</label>
                                <InputText v-model="email" id="email" class="flex-auto" autocomplete="on" />
                            </div>
                            <div class="flex justify-end gap-2">
                                <Button type="button" label="Cancel" severity="secondary"
                                    @click="bookDemoModal = false"></Button>
                                <Button type="button" label="Request" @click="requestDemo"></Button>
                            </div>
                        </Dialog>
                        <VideoButton />
                    </div>

                    <div class="mt-32">
                        <!-- <div class="bg-white py-24 sm:py-32">
                            <div class="mx-auto max-w-7xl px-6 lg:px-8">
                                <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
                                    <div v-for="stat in stats" :key="stat.id"
                                        class="mx-auto flex max-w-xs flex-col gap-y-4">
                                        <dt class="text-base/7 text-gray-600">{{ stat.name }}</dt>
                                        <dd
                                            class="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                                            {{
                                            stat.value }}</dd>
                                    </div>
                                </dl>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="relative mt-10 sm:mt-20 lg:col-span-5 lg:row-span-2 lg:mt-0 xl:col-span-6">
                    <!-- <AnimatedHalfCircles /> -->
                    <div
                        class="-mx-4 h-[448px] [mask-image:linear-gradient(to_bottom,white_60%,transparent)] px-9 sm:mx-0 lg:absolute lg:-inset-x-10 lg:-top-10 lg:-bottom-20 lg:h-auto lg:px-0 lg:pt-10 xl:-bottom-32">
                        <div class="relative aspect-[266/400] mx-auto max-w-[366px]">
                            <img src="/images/home/header.jpg"
                                class="absolute inset-0 h-full w-full object-cover object-center rounded-full" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import VideoButton from '@/components/buttons/VideoButton.vue';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import { requestDemoService } from '@/services/requestDemoService';
import { ref } from 'vue';

const props = defineProps(['title', 'image']);
const bookDemoModal = ref(false);
const email = ref('');

const data = {
    subtitle: 'Welcome to',
    title: props.title,
    description: 'Join us and experience an enriching journey through our online Quran, Arabic, and Islamic studies programs. Our Native Arabic tutors proficient in English.',
    buttonText: 'Book a Free Demo',
    buttonLink: '#'
};

const image = {
    alt: 'Image of a person studying Quran - Photo by Furkan Dil'
};

const requestDemo = () => {
    console.log('Requesting demo with email:', email.value);
    requestDemoService({ email: email.value })
        .then(() => {
            bookDemoModal.value = false;
        })
        .catch(() => {
            alert('There was an error processing your request. Please try again later.');
        });
};
</script>
